module.exports = __webpack_public_path__ + "static/media/proj20_img8.d03ad907.jpg";